import { $definitions } from 'ziphy-web-shared/basic/entities/notes/definitions';
import { getUuid } from 'ziphy-web-shared/basic/helpers';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
const placeholderRegex = /^{{.*}}$/;
const getPlaceholderIDs = (string) => string.slice(2, -2).split(':');
const newText = (value) => ({
    id: getUuid(),
    value,
    type: 'text',
});
const newInput = (value) => ({
    id: getUuid(),
    value,
    type: 'input',
});
const newPlaceholder = (value, macroType, macroId) => ({
    id: getUuid(),
    value,
    type: 'placeholder',
    macroType,
    macroId,
});
const getPlaceholderValue = (data) => {
    if (data.type === 'select' || data.type === 'text') {
        if (Array.isArray(data.value) && data.value.length) {
            return data.value.join(', ');
        }
        else if (!Array.isArray(data.value) && data.value) {
            return data.value;
        }
        else {
            return data.title;
        }
    }
    else if (data.type === 'resource') {
        return Array.isArray(data.value) ? data.value.join(', ') : data.value || '';
    }
    else if (data.type === 'date') {
        return data.value ? formatDate(data.value, data.format) : '';
    }
    return '';
};
class TextBlockDataHelpers {
    static parseText(text) {
        const regex = /(\{\{[^}]+\}\})/g; // Matches {{...}}
        return text.split(regex);
    }
    static convertTextListToObjectList(textList) {
        return textList.map((text) => {
            if (placeholderRegex.test(text)) {
                const [type, id] = getPlaceholderIDs(text);
                return newPlaceholder(text, type, id);
            }
            else {
                return newText(text);
            }
        });
    }
    static defineElementData(elements, data) {
        elements.forEach((item, index) => {
            if (item.type === 'placeholder' && data[item.macroId]) {
                item.macroData = data[item.macroId];
            }
            else if (item.type === 'placeholder' && !data[item.macroId]) {
                elements[index] = newText(item.value);
            }
        });
        return elements;
    }
    static compare(elements, data) {
        const result = {
            hasNewData: false,
            changedElementIds: [],
        };
        Object.keys(data).forEach((macroId) => {
            const item = elements.find((item) => item.type === 'placeholder' && item.macroId === macroId);
            if (item) {
                const oldData = item.macroData;
                const newData = data[macroId];
                if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
                    result.changedElementIds.push(item.id);
                }
            }
            else {
                result.hasNewData = true;
            }
        });
        return result;
    }
    static mergeElements(elements) {
        return elements.reduce((previousValue, currentValue) => {
            var _a;
            let value = '';
            if (currentValue.type === 'placeholder') {
                const placeholder = currentValue.macroData;
                if (placeholder.type === 'select') {
                    const selectValuesMap = $definitions.selects.valuesMap(placeholder.selectId);
                    if (placeholder.multi && Array.isArray(placeholder.value)) {
                        value = placeholder.value.map((item) => { var _a; return ((_a = selectValuesMap[item]) === null || _a === void 0 ? void 0 : _a.title) || item; }).join(', ');
                    }
                    else if (!placeholder.multi && typeof placeholder.value === 'string') {
                        value = ((_a = selectValuesMap[placeholder.value]) === null || _a === void 0 ? void 0 : _a.title) || placeholder.value;
                    }
                    else {
                        value = placeholder.title;
                    }
                }
                else if (placeholder.type === 'date') {
                    value = placeholder.value
                        ? formatDate(placeholder.value, placeholder.format)
                        : placeholder.title;
                }
                else {
                    value = placeholder.value
                        ? Array.isArray(placeholder.value)
                            ? placeholder.value.length > 0
                                ? placeholder.value.join(', ')
                                : placeholder.title
                            : placeholder.value
                        : placeholder.title;
                }
            }
            else if (currentValue.type === 'text') {
                value = currentValue.value;
            }
            return previousValue + value;
        }, '');
    }
    static convertObjectListToText(objectList, format = 'backend') {
        return objectList.reduce((result, item) => {
            if (item.type === 'text') {
                result += item.value;
            }
            else if (item.type === 'placeholder') {
                result +=
                    format === 'plainText'
                        ? getPlaceholderValue(item.macroData)
                        : `{{${item.macroType}:${item.macroId}}}`;
            }
            else if (item.type === 'input' && item.macroId) {
                let macro = item.macroId;
                if (Array.isArray(item.fhirRef) && item.fhirRef.length) {
                    macro += ':' + item.fhirRef.join(',');
                }
                else if (typeof item.fhirRef === 'string' && item.fhirRef) {
                    macro += ':' + item.fhirRef;
                }
                result += `%%${macro}%%`;
            }
            return result;
        }, '');
    }
}
TextBlockDataHelpers.newText = newText;
TextBlockDataHelpers.newInput = newInput;
TextBlockDataHelpers.newPlaceholder = newPlaceholder;
export default TextBlockDataHelpers;
